module.exports = __webpack_public_path__ + "static/img/membership-modal-logo.dcf1ae1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/membership-modal-logo.png
// module id = 1218
// module chunks = 14 15 17 27 98